import { createAsyncThunk } from '@reduxjs/toolkit';

import { scenarioApi, setScenario, setError, setLoading } from '../model';

export const getOfferDisbursementStepThunk = createAsyncThunk(
  'scenario/getOfferDisbursementStep',
  async (hashedDealId: string, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(false));

      const offerDisbursementStep = await dispatch(
        scenarioApi.endpoints.getOfferDisbursementStep.initiate(hashedDealId),
      ).unwrap();

      if (!offerDisbursementStep?.content) {
        throw new Error('No content in offer disbursement step');
      }

      dispatch(setScenario(offerDisbursementStep));
      return offerDisbursementStep;
    } catch (error) {
      dispatch(setError(true));

      return rejectWithValue(error.message);
    } finally {
      dispatch(setLoading(false));
    }
  },
);
